import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Quiz } from './components/quiz/Quiz';
import { CinemaNews } from './CinemaNews';
import { TweetBotz } from './TweetBotz';
import { ReelsBotz } from './ReelsBotz';
import { MemeBotz } from './MemeBotz';
import { SongBotz } from './SongBotz';
import './HomePage.css';

export function HomePage({ user }) {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const el = document.getElementById(id);
    if (el) {
      requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }, [location.hash]);

  return (
    <div className="home-page">
      <section className="home-section home-section--quiz" aria-labelledby="quiz-heading">
        <h2 id="quiz-heading" className="home-section-title">Quiz Botz</h2>
        <p className="home-section-tagline">Daily five new cine questions about cinema.</p>
        <div className="home-section-content">
          <Quiz user={user} />
        </div>
      </section>

      <section className="home-section home-section--song" aria-labelledby="song-heading">
        <h2 id="song-heading" className="home-section-title">Song Botz</h2>
        <div className="home-section-content">
          <SongBotz />
        </div>
      </section>

      <section className="home-section home-section--news" aria-labelledby="news-heading">
        <h2 id="news-heading" className="home-section-title">News Botz</h2>
        <div className="home-section-content">
          <CinemaNews />
        </div>
      </section>

      <section className="home-section home-section--tweet" aria-labelledby="tweet-heading">
        <h2 id="tweet-heading" className="home-section-title">Tweet Botz</h2>
        <div className="home-section-content">
          <TweetBotz />
        </div>
      </section>

      <section className="home-section home-section--reels" aria-labelledby="reels-heading">
        <h2 id="reels-heading" className="home-section-title">Reels Botz</h2>
        <div className="home-section-content">
          <ReelsBotz />
        </div>
      </section>

      <section className="home-section home-section--memes" aria-labelledby="memes-heading">
        <h2 id="memes-heading" className="home-section-title">Meme Botz</h2>
        <div className="home-section-content">
          <MemeBotz />
        </div>
      </section>
    </div>
  );
}

export default HomePage;
